import {type Operation} from '../state/graphql/apolloWithAbort';

/**
 * Reads the backend (gorilla) trace id from the X-Wandb-Trace-Id response
 * header: first off a non-2xx networkError's response, then off the operation
 * context. Returns undefined when absent — Headers.get yields null on a missing
 * header, so we coalesce to a clean string | undefined.
 */
export function getWandbTraceId(
  networkError: unknown,
  operation: Operation
): string | undefined {
  return (
    (networkError as any)?.response?.headers?.get?.('x-wandb-trace-id') ??
    operation.getContext().response?.headers?.get?.('x-wandb-trace-id') ??
    undefined
  );
}

/**
 * Datadog RUM resource events store the low 64 bits of an OpenTelemetry trace
 * ID as an unsigned decimal string. Convert the response-header trace ID into
 * that representation so custom vitals can be joined to their resource event.
 */
export function wandbTraceIdToDatadogTraceId(
  traceId: string | undefined
): string | undefined {
  if (!traceId || !/^[0-9a-f]{32}$/i.test(traceId)) {
    return undefined;
  }

  return BigInt(`0x${traceId.slice(-16)}`).toString(10);
}
